import { useQuery } from '@tanstack/react-query';
import { getVideoPlacements } from '../services/admin/admin-video.service';
import { ADMIN_VIDEO_PLACEMENTS_KEY } from '../common/utils/video-query-cache';

export function useVideoPlacements() {
  return useQuery({
    queryKey: [ADMIN_VIDEO_PLACEMENTS_KEY],
    queryFn: getVideoPlacements,
    staleTime: Infinity,
  });
}
